import React from 'react';
import CalculatorPump from '../components/CalculatorPump.js';

const CalculatorPumpText = () => {
    return (
        <>
            <div className="w-full flex justify-center py-6 px-4 sm:px-8 md:px-16">
                <div className="w-full lg:w-3/4 bg-white px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl">
                    <h1 className="text-3xl font-bold text-primary mb-6">Fördermöglichkeiten für Ihre Heizungsmodernisierung</h1>
                    <p className="text-lg text-gray-800 mb-6">
                        Private Haushalte profitieren von verschiedenen staatlichen Förderprogrammen, die finanzielle Anreize für die Modernisierung von Heizungsanlagen bieten. Dabei können sowohl der Austausch älterer Systeme als auch die Installation neuer, effizienter und umweltfreundlicher Technologien wie Wärmepumpen oder Solarthermie gefördert werden.
                    </p>

                    <div className='mt-16 mb-16'>
                        <CalculatorPump />
                    </div>

                    <h2 className="text-2xl font-semibold text-black mb-4">Förderziel:</h2>
                    <p className="text-lg text-gray-800 mb-6">
                        Der Schwerpunkt dieser Programme liegt auf der Reduzierung des Energieverbrauchs und dem Schutz der Umwelt. Gleichzeitig sollen die finanziellen Belastungen für Hauseigentümer durch die Investition in nachhaltige Technologien deutlich gesenkt werden.
                    </p>

                    <h2 className="text-2xl font-semibold text-black mb-4">Wichtige Hinweise:</h2>
                    <p className="text-lg text-gray-800 mb-6">
                        Mit diesen Förderungen wird es einfacher, auf moderne Heizsysteme umzusteigen und langfristig Kosten zu sparen. Sie bieten eine wertvolle Unterstützung, um die Ziele der Energieeffizienz und der Umweltfreundlichkeit zu erreichen.
                    </p>

                    <h2 className="text-2xl font-semibold text-black mb-4">Förderhöhe:</h2>
                    <ul className="list-disc list-inside text-lg text-gray-800 mb-6">
                        <li><strong>Grundförderung:</strong> Der Prozentsatz der Förderung variiert je nach Maßnahme und Region.</li>
                        <li><strong>Bonus für innovative Technologien:</strong> Höhere Zuschüsse für besonders umweltfreundliche Heiztechniken.</li>
                    </ul>

                    <p className="text-lg text-gray-800 mb-6">
                        Mit den staatlichen Förderungen können Sie die Umstellung auf moderne Heiztechnologien leichter finanzieren und langfristig von geringeren Energiekosten profitieren.
                    </p>

                </div>
            </div>
        </>
    );
};

export default CalculatorPumpText;
